import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import { ToolPanel } from '../ui'
import { RevenueSpendUiSettingsTable } from './RevenueSpendUiSettingsTable'
import * as lib from '../../lib'

import * as state from '../../states'
import { useAtomValue, useSetAtom, useAtom } from 'jotai'
import { IAccountBuyer, IFetchAuthProfile, IRevenueAgencyDropDown } from '../../types'
import { revenueAgencyOptionLabel } from './helpers'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendUiSettingsModalProps = {
	revenueAgency: IRevenueAgencyDropDown
	show: boolean
	take: number | 'all'
	onClose: () => void
	onSave: () => void
}

export const RevenueSpendUiSettingsModal = (
	props: IRevenueSpendUiSettingsModalProps
) => {
	const { t } = useTranslation()
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)
	const tokens = useAtomValue(state.tokensAtom)
	const [profile, setProfile] = useAtom(state.profileAtom)
	const $access = new lib.Access(profile ?? null)

	const { revenueAgency, show, take = 10, onClose, onSave } = props
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const buyerItems = useAtomValue(state.accountBuyersAtom)

	const [selectedRows, setSelectedRows] = useState<IAccountBuyer[]>([])
	const onMultiSelect = (selectedRows: IAccountBuyer[]) => {
		setSelectedRows(selectedRows)
	}

	const onUpdate = async (event: React.MouseEvent) => {
		const uri = 'auth/profile/ui'
		const method: string = 'PUT'
		const params: lib.FetchOptions['params'] = {}
		const headers = lib.bearer(tokens?.access)
		try {
			const body: string = JSON.stringify({
				ui: {
					...profile?.setup?.ui,
					revenueSpendBuyers: {
						...profile?.setup?.ui?.revenueSpendBuyers,
						[revenueAgency.id]: selectedRows.map(item => item.id)
					}
				}
			})
			const options: lib.FetchOptions = { body, method, params, headers }
			setFetchIsLoading(state.turnOnLoader)
			const updatedProfile = await lib.fetching<IFetchAuthProfile>(uri, options)
			updatedProfile && setProfile(updatedProfile.profile)
			onSave()
		} catch (error: unknown) {
			// TODO: pretty notification alert
			console.error(error)
		} finally {
			setFetchIsLoading(state.turnOffLoader)
		}
	}

	const revenueAgencyLabel = revenueAgencyOptionLabel(revenueAgency)
	const modalTitle = `${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_select_users)} - ${revenueAgencyLabel}`

	return <>
		<Modal show={show}
		       onHide={onClose}
		       size="xl"
		       scrollable={true}
		       fullscreen={true}
		       /*contentClassName={'modal-content--full-height'}*/
		>
			<Modal.Header closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body className={'scroll'}>
				<RevenueSpendUiSettingsTable
					revenueAgencyId={revenueAgency.id}
					items={buyerItems ?? []}
					skip={skip}
					onMultiSelect={onMultiSelect}
				/>
			</Modal.Body>

			<Modal.Footer>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="primary" onClick={onUpdate}>{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_update)}`}</Button>
					<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_close)}`}</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
